import {visualizeTrackingEvent} from './eventVisualization';

type LicenseActionRoute = {
    method: string;
    pattern: RegExp;
    label: string | ((match: RegExpMatchArray, body: unknown) => string);
};

// Mirrors the license_action custom events emitted by the backend LicenseActionTracker
// (labels in src/Service/Tracking/LicenseActionLabel.php). The backend emits them inside
// the API endpoints matched below, so the frontend requests to those endpoints are used
// to visualize the actions as toasts.
const LICENSE_ACTION_ROUTES: LicenseActionRoute[] = [
    {
        method: 'GET',
        pattern:
            /^\/api\/admin\/subscription\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
        label: 'Lizenzübersicht aufgerufen',
    },
    {
        method: 'GET',
        pattern: /^\/api\/admin\/subscription-prices$/,
        label: 'Preistabelle aufgerufen',
    },
    {
        method: 'GET',
        pattern: /^\/api\/admin\/subscription\/licenses\/[^/]+\/allowed-amount$/,
        label: 'Lizenz-Kauf-Dialog geöffnet',
    },
    {
        method: 'GET',
        pattern: /^\/api\/admin\/subscription\/licenses\/[^/]+\/cost(?:\/\d+)?$/,
        label: 'Lizenzkosten angefragt',
    },
    {
        method: 'POST',
        pattern: /^\/api\/admin\/subscription\/portal-url\/[^/]+$/,
        label: 'Stripe-Portal geöffnet',
    },
    {
        method: 'POST',
        pattern: /^\/api\/admin\/subscription\/edit\/[^/]+$/,
        label: (_match, body) =>
            body instanceof FormData && body.get('subscription[assignAutomatically]') === 'true'
                ? 'Automatische Lizenzvergabe aktiviert'
                : 'Automatische Lizenzvergabe deaktiviert',
    },
    {
        method: 'PUT',
        pattern: /^\/api\/admin\/subscription\/licenses\/[^/]+\/increase\/(\d+)$/,
        label: match => {
            const numberOfLicenses = Number(match[1]);

            return numberOfLicenses === 1
                ? '1 Lizenz per Self-Service gekauft'
                : `${numberOfLicenses} Lizenzen per Self-Service gekauft`;
        },
    },
    {
        method: 'POST',
        pattern: /^\/api\/admin\/payment\/checkout$/,
        label: 'Checkout gestartet',
    },
];

export function matchLicenseAction(method: string, url: string, body: unknown): string | null {
    for (const route of LICENSE_ACTION_ROUTES) {
        if (route.method !== method) {
            continue;
        }

        const match = url.match(route.pattern);
        if (!match) {
            continue;
        }

        return typeof route.label === 'string' ? route.label : route.label(match, body);
    }

    return null;
}

export function visualizeLicenseActionRequest(method: string, url: string, body: unknown): void {
    const label = matchLicenseAction(method, url, body);

    if (label !== null) {
        visualizeTrackingEvent('Event (Lizenz-Aktion)', label);
    }
}
